export const environment = {
  production: true,
  buildId: '4200602275025041',
  configFile: 'config.json',
};
